import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuperAdminService } from '../../../services/super-admin/super-admin.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// create or edit a permission. On edit the permission name is immutable (matches
// the backend). data = { permission } for edit, or null/undefined for create.
@Component({
  selector: 'app-sa-permission-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './sa-permission-dialog.component.html',
  styleUrls: ['./sa-permission-dialog.component.scss', '../../../../common-style/dropdown.scss', '../../../../common-style/ac-dialog.scss'],
})
export class SaPermissionDialogComponent implements OnInit {
  form: FormGroup;
  isEdit: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SaPermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { permission?: any },
    private superAdminService: SuperAdminService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      permissionName: ['', Validators.required],
      permLabel: ['', Validators.required],
      isDefaultPermission: [false],
      status: [1],
    });
  }

  ngOnInit(): void {
    const permission = this.data?.permission;
    if (permission) {
      this.isEdit = true;
      this.form.patchValue({
        permissionName: permission.permissionName,
        permLabel: permission.permLabel,
        isDefaultPermission: permission.isDefaultPermission,
        status: permission.status,
      });
      this.form.get('permissionName')?.disable(); // name is immutable on edit
    }
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error('Name and label are required.');
      return;
    }
    this.isLoading = true;
    const payload = this.form.getRawValue();
    const permission = this.data?.permission;
    const request$ = this.isEdit
      ? this.superAdminService.updatePermission(permission.permissionId, payload)
      : this.superAdminService.createPermission(payload);
    request$.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Saved.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save permission.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
